export const TRANSACTION_APIS = {
  validate_refunds: "payments/validate/refunds",
  initiate_refunds: "payments/initiate/refunds",
  status_refund_order: "payments/refunds/order/status",
  refund_history_retry: "payments/refunds/retry",
};
